import React from 'react'
import Buttoncategories from '../buttons/Buttoncategories'



export default function Categories() {
  return (
    <div>
        <h1 className="flex justify-center items-center py-2 xl:text-3xl text-2xl font-bold leading-9 text-gray-900">Categorías</h1>
        <Buttoncategories />
    </div>
  )
}
